import { useEffect } from "react";

const LeadsRedirect = () => {
  useEffect(() => {
    window.location.replace("/leads.html");
  }, []);
  return (
    <div data-testid="leads-redirect" style={{ minHeight: "100vh", background: "#0A1E3F" }} />
  );
};

export default LeadsRedirect;
